define('Custom.Order.History.View',	[
  'custom_order_history.tpl',
  'CustomMyAccountData.Model',
  'Backbone'
], function (
  Template,
  CustomMyAccountDataModel,
  Backbone
) {
  'use strict';

  return Backbone.View.extend({

    template: Template,

    initialize: function (options) {
      var self = this;
      var jsonresp = '';

      // var userProfile = container.getComponent('UserProfile');
      // userProfile.getUserProfile().then(function(profile) {
      // 	self.internalid = profile.internalid;
      // });

      self.trantype = options.trantype || 'orders';
      self.title = options.title || 'Order History';
      self.isReturn = options.isReturn || false;
      self.model = new CustomMyAccountDataModel();
      self.loading = true;

      self.model.fetch({
        async: false,
        data: { trantype: self.trantype}
      }).done(function (result) {
        if(result && result.apiresp && result.apiresp.length > 0) {
          jsonresp = JSON.parse(result.apiresp);
          if(jsonresp && jsonresp.url) {
            self.url = jsonresp.url;
            self.loading = false;
            self.render();
          }
        }
      });

      // if(config && config.requestData && config.apiurl){
      // 	self.requestData = config.requestData;
      // 	self.apiurl = config.apiurl;
      // 	self.errorMessage = config.errorMessage || 'Error encountered, please contact your administrator.';
      //
      // 	var thisHeaders = _.filter(self.requestData, function(tisData){
      // 		return tisData.type == 'header' && tisData.section == 'orderhistory';
      // 	});
      // 	var thisParams = _.filter(self.requestData, function(tisData){
      // 		return tisData.type == 'parameter' && tisData.section == 'orderhistory';
      // 	});
      //
      // 	self.header = {};
      // 	self.params = {};
      //
      // 	_.each(thisHeaders, function(tisHeader){
      // 		self.header[tisHeader.name] = tisHeader.value;
      // 	});
      //
      // 	_.each(thisParams, function(tisParam){
      // 		self.params[tisParam.name] = tisParam.value;
      // 	});
      //
      // 	$.ajax({
      // 		type: "POST",
      // 		url: self.apiurl,
      // 		headers: self.header,
      // 		data: self.params,
      // 		crossDomain: true,
      // 		success: function (data) {
      // 			if(data.message && data.message == 'success' && data.url){
      // 				self.url = data.url;
      // 				self.loading = false;
      // 				self.render();
      // 			}
      // 		}
      // 	});
      // }

    },

    events: {
    },

    bindings: {
    },

    childViews: {

    },

    // @method getContext @return Kodella.CustomMyAccountData.Main.View.Context
    getContext: function getContext() {
      var self = this;

      return {
        title: self.title,
        isReturn: self.isReturn,
        url: self.url || false,
        loading: self.loading,
        errorMessage: self.errorMessage
      };
    }
  });
});
